var UpdateSerialiser = require('../../update/serialiser');
var Codec = require('io/codec');

module.exports = {
    read : function(input) {
        return {
            path : Codec.readString(input),
            update : UpdateSerialiser.read(input)
        };
    },
    write : function(output, request) {
        Codec.writeString(output, request.path);
        UpdateSerialiser.write(output, request.update);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/update-topic/update-topic-request-serialiser.js
// module id = 1090
// module chunks = 1